<script lang="ts">
    interface Props {
        group: any
        value: any
        label?: string
        checked?: boolean
        required?: boolean
    }

    let { group = $bindable(), value, label = "", checked = undefined, required = undefined }: Props = $props()

    let id = "_" + Math.random().toString(36).substr(2, 9)
</script>

<div class="inputholder">
    <input {id} {checked} type="radio" bind:group {value} name={group} {required} />
    <label for={id}><span>{label}</span> </label>
</div>

<style lang="less">
    .inputholder {
        position: relative;
        margin-bottom: 15px;
        input[type="radio"] {
            width: auto;
            opacity: 0.00000001;
            position: absolute;
            left: 0;
            margin-left: -20px;
        }
        label {
            position: relative;
            min-height: 25px;
            display: block;
            padding-left: 40px;
            margin-bottom: 0;
            font-weight: normal;
            cursor: pointer;
            display: flex;
            display: -webkit-flex;
            align-items: center;
            font-size: 1rem;
            line-height: 1;
            text-transform: none;
            &:before {
                content: "";
                position: absolute;
                left: 0;
                top: 0px;
                width: 25px;
                height: 25px;
                transition: transform 0.28s ease;
                border-radius: 3px;
                border-radius: 100%;
                border: solid 1px rgb(97, 238, 3);
            }
            &:after {
                transition: all 0.3s;
                content: "";
                display: block;
                position: absolute;
                top: 5px;
                bottom: 5px;
                left: 5px;
                width: 17px;
                height: 17px;
                border-radius: 100%;
                background: transparent;
            }
        }
        input[type="radio"]:checked ~ label:after {
            background: rgb(97, 238, 3);
        }
    }
</style>
